import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { auth, db } from "./firebase";
import { doc, getDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import {
  fetchData,
  selectIsLoading,
  selectUser,
  selectTilesDetails,
  selectRestrictedDataError,
} from "../../mainApp/features/DataSlice/dataSlice";
import LoadingPage from "../components/TechnicalTabs/LoadingPage";
import ErrorPage from "../components/TechnicalTabs/ErrorPage";
import { handleLoginAccess } from "./Utility/handleLoginAccess";
import ImageSkeleton from "./UiComponents/ImageSkeleton"; // Nowy import
import "./LoginForm.css";

function Profile() {
  const [userDetails, setUserDetails] = useState(null);
  const [initialLoading, setInitialLoading] = useState(true);
  const [isImageLoading, setIsImageLoading] = useState(false);
  const tilesDetails = useSelector(selectTilesDetails);
  const restrictedDataError = useSelector(selectRestrictedDataError);
  const isLoading = useSelector(selectIsLoading);
  const user = useSelector(selectUser);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Funkcja opóźnienia
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  // Pobierz dane użytkownika i zainicjuj dane Redux
  useEffect(() => {
    dispatch(fetchData());
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        try {
          const docRef = doc(db, "Users", currentUser.uid);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            setUserDetails(docSnap.data());
          } else {
            console.warn("Dokument użytkownika nie istnieje.");
            setUserDetails({
              email: currentUser.email,
              firstName: "",
              photo: "",
            });
          }
          await delay(600); // Dodatkowe opóźnienie jako zabezpieczenie
        } catch (error) {
          console.error("Błąd pobierania danych użytkownika:", error);
          setUserDetails({
            email: currentUser.email,
            firstName: "",
            photo: "",
          });
          await delay(600); // Opóźnienie w przypadku błędu
        }
      } else {
        navigate("/login");
      }
      setInitialLoading(false);
    });
    return () => unsubscribe();
  }, [dispatch, navigate]);

  // Sprawdzanie stanu obrazu po załadowaniu userDetails
  useEffect(() => {
   
    if (userDetails) {
      const img = new Image();
      img.src = userDetails.photo || require("./Assets/jakub.png");
      if (img.complete) {
        console.log("Image already in cache");
        setIsImageLoading(false);
      } else {
        console.log("Image not in cache, setting isImageLoading to true");
        setIsImageLoading(true);
        img.onload = () => {
          console.log("Image loaded via preload");
          setIsImageLoading(false);
        };
      }
    }
  }, [userDetails]);

  async function handleLogout() {
    try {
      await auth.signOut();
      navigate("/login");
      console.log("Użytkownik pomyślnie wylogowany!");
    } catch (error) {
      console.error("Error logging out:", error.message);
    }
  }

  const handleAINavigation = () => {
    if (restrictedDataError) {
      navigate("/pricing");
    } else if (tilesDetails.length > 0 && !restrictedDataError) {
      navigate("/home");
    } else {
      navigate("/pricing");
    }
  };

  if (initialLoading || isLoading === "loading") {
    return <LoadingPage />;
  }

  let returned;

  switch (isLoading) {
    case "success":
      if (!user) {
        returned = <LoadingPage isHighZIndex={true} />;
      } else {
        returned = userDetails ? (
          <div className="wrapper">
            <div className="image-container">
              <ImageSkeleton
                width="150px"
                height="150px"
                hidden={!isImageLoading}
              />
              <img
                alt="Avatar"
                src={userDetails.photo || require("./Assets/jakub.png")}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = require("./Assets/jakub.png");
                }}
                onLoad={() => {
                  console.log("Image loaded via onLoad");
                  setIsImageLoading(false);
                }}
                className={`profile-image ${isImageLoading ? "hidden" : ""}`}
              />
            </div>
            <br />
            <h3>Witaj {userDetails.firstName || "User"} 🙏🙏</h3>
            <div>
              <p>Email: {userDetails.email || "N/A"}</p>
              <p>Imię: {userDetails.firstName || "N/A"}</p>
            </div>
            <br />
            <button onClick={handleAINavigation}>Wejdź do AI</button>
            <br />
            <br />
            <button onClick={handleLogout}>Wyloguj się</button>
          </div>
        ) : (
          handleLoginAccess()
        );
      }
      break;
    case "error":
      returned = <ErrorPage />;
      break;
    default:
      returned = <LoadingPage />;
  }

  return returned;
}

export default Profile;